import stockService from 'stockService'
import utils from 'utils'

export default class retrieveService {
    constructor($q, httpRequest) {
        this.$q = $q
        this.httpRequest = httpRequest
    }

    getDiskInfo() {
        return new Promise((resolve, reject) => {
            stockService.getDiskInfo().then((res) => {
                resolve(JSON.parse(res))
            }, (err) => {
                reject(err)
            })
        })
    }

    setDataListIfDiskCode0(currDiskCode) {
        const service = this
        return new Promise((resolve, reject) => {
            if (currDiskCode != 0) {
                reject()
            } else {
                stockService.queryRetrieve().then((res) => {
                    console.log(res)
                    service.httpRequest.post_qryOvatInvoiceCollect({
                        diskCode: currDiskCode,
                        reportXml: res,
                    }).then((data) => {
                        if (data.data.value) {
                            resolve(data.data.value)
                        }
                    })
                })
            }
        })
    }

    setDataListIfDiskType2() {
        return new Promise((resolve, reject) => {
            stockService.queryInvoiceStock().then((res) => {
                const reg = {
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                    categoryCode: /<LBDM>(.*?)<\/LBDM>/g,
                    invoiceType: /<FPZL>(.*?)<\/FPZL>/g,
                    startNumber: /<QSHM>(.*?)<\/QSHM>/g,
                    collectCount: /<FPFS>(.*?)<\/FPFS>/g,
                    gmrq: /<GMRQ>(.*?)<\/GMRQ>/g,
                    id: /<FPJH>(.*?)<\/FPJH>/g,
                }
                resolve(utils.analysisXml(reg, res).value)
            })
        })
    }

    get_qryServerDiskOfPlugged(diskCode) {
        const service = this
        const reg = {
            categoryCode: /<TypeCode>(.*?)<\/TypeCode>/g,
            invoiceType: /<InvKind>(.*?)<\/InvKind>/g,
            startNumber: /<StartNO>(.*?)<\/StartNO>/g,
            count: /<Count>(.*?)<\/Count>/g,
            collectCount: /<Remain>(.*?)<\/Remain>/g,
            ukeyCode: /<Machine>(.*?)<\/Machine>/g,
            gmrq: /<BuyDate>(.*?)<\/BuyDate>/g,
            id: /<ID>(.*?)<\/ID>/g,
        }
        return new Promise((resolve, reject) => {
            service.httpRequest.get_qryServerDiskOfPlugged({ diskCode }).then((res) => {
                resolve({ diskCode: res.data.value.diskCode, resArr: utils.analysisXml(reg, res.data.value.reportXml).value })
            })
        })
    }

    queryRetrieve() {
        const service = this
        return new Promise((resolve, reject) => {
            stockService.queryRetrieve().then((res) => {
                service.httpRequest.post_qryOvatInvoiceCollect({
                    diskCode: 0,
                    reportXml: res,
                }).then((data) => {
                    resolve(data.data.value)
                })
            })
        })
    }

    queryInvoiceStock() {
        const reg = {
            code: /(<CODE>)(.*?)(<\/CODE>)/g,
            categoryCode: /<LBDM>(.*?)<\/LBDM>/g,
            invoiceType: /<FPZL>(.*?)<\/FPZL>/g,
            startNumber: /<QSHM>(.*?)<\/QSHM>/g,
            collectCount: /<FPFS>(.*?)<\/FPFS>/g,
            gmrq: /<GMRQ>(.*?)<\/GMRQ>/g,
            id: /<FPJH>(.*?)<\/FPJH>/g,
        }
        return new Promise((resolve, reject) => {
            stockService.queryInvoiceStock().then((res) => {
                resolve(utils.analysisXml(reg, res).value)
            })
        })
    }

    retreatInvoiceBranch(obj, diskCode) {
        const service = this
        return new Promise((resolve, reject) => {
            stockService.retreatInvoiceBranch({
                invType: obj.invoiceType,
                typeCode: obj.categoryCode,
                startNumber: obj.startNumber,
                invNumber: obj.collectCount,
                invNum: obj.id,
            }).then((res) => {
                const resCode = utils.analysisXml({
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                }, res).code
                const resMsg = utils.analysisXml({
                    msg: /(<MESS>)(.*?)(<\/MESS>)/g,
                }, res).value[0]
                console.log(resCode, resMsg)
                if (resCode == '0000') {
                    service.httpRequest.post_addBackOperateRecord({
                        allotCount: obj.count,
                        backPointCode: diskCode,
                        collectPointCode: 0,
                        invoiceCount: obj.collectCount,
                        invoiceNumberStart: obj.startNumber,
                        invoiceType: obj.invoiceType,
                        invoiceTypeCode: obj.categoryCode,
                    }).then((res) => {
                        if (res.data.success) {
                            resolve()
                        }
                    })
                } else {
                    reject(resMsg.msg)
                }
            }, (error) => {
                reject(error)
            })
        })
    }

    post_returnServerDiskInvoiceFromUkey(obj, diskCode) {
        const service = this
        return new Promise((resolve, reject) => {
            service.httpRequest.post_returnServerDiskInvoiceFromUkey({
                clientNo: obj.ukeyCode,
                invoiceCount: obj.collectCount,
                invoiceNumber: obj.startNumber,
                invoiceType: obj.invoiceType,
                serverDiskCode: diskCode,
                typeCode: obj.categoryCode,
            }).then((res) => {
                if (res.data.success) {
                    service.httpRequest.post_addSonDiskCollectOperateRecord({
                        allotCount: obj.count,
                        backPointCode: obj.ukeyCode,
                        collectPointCode: diskCode,
                        invoiceCount: obj.collectCount,
                        invoiceNumberStart: obj.startNumber,
                        invoiceType: obj.invoiceType,
                        invoiceTypeCode: obj.categoryCode,
                    }).then((res) => {
                        if (res.data.success) {
                            resolve()
                        }
                    })
                }
            })
        })
    }

    mainRetrieve(obj) {
        const service = this
        return new Promise((resolve, reject) => {
            stockService.mainRetrieve({
                invType: obj.invoiceType,
                typeCode: obj.categoryCode,
                startNumber: obj.startNumber,
                invNumber: obj.collectCount,
            }).then((res) => {
                const resCode = utils.analysisXml({
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                }, res).code
                const resMsg = utils.analysisXml({
                    msg: /(<MESS>)(.*?)(<\/MESS>)/g,
                }, res).value[0]
                console.log(resCode, resMsg)
                if (resCode == '0000') {
                    service.httpRequest.post_addMainDiskCollectOperateRecord({
                        allotCount: obj.applyCount,
                        backPointCode: obj.invoicePointCode,
                        collectPointCode: 0,
                        invoiceCount: obj.collectCount,
                        invoiceNumberStart: obj.startNumber,
                        invoiceType: obj.invoiceType,
                        invoiceTypeCode: obj.categoryCode,
                    }).then((res) => {
                        if (res.data.success) {
                            resolve()
                        }
                    })
                } else {
                    reject(resMsg.msg)
                }
            }, (error) => {
                reject(error)
            })
        })
    }
}
retrieveService.$inject = ['$q', 'httpRequest']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/retrieve/service/RetrieveService.js